<div class="row d-flex flex-row container-fluid">
  <div class="form-group mb-2">
    <label>Review</label>
    <textarea rows="5" cols="100" [(ngModel)]="reviewText" class="form-control"
      placeholder="Share your review"></textarea>
  </div>

  <div class="form-group container-fluidss d-flex flex-column ml-2 mb-0">
    <label>Overall Rating</label>
    <ngb-rating [max]="5" [(rate)]="reviewRating" [readonly]="false"></ngb-rating>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <button class="btn btn-primary float-right" (click)="onReviewSave()">Save</button>
  </div>
</div>